import { FeatureConfig } from '@typesApp/Config'

const BrandFeatureConfig = {
  ebd: {
    disableAuthTokenSessionIdCheck: true,
  },
  nua: {
    disableInsuranceToggleMessages: true,
  },
  vde: {
    validateInsurerEligibleProduct: true,
  },
} as Record<string, FeatureConfig>

const EnvBrandFeatureConfig = {
  STAGE: {
    vde: {
      ...BrandFeatureConfig['vde'],
      disableStrictSSNValidation: true,
    },
  },
} as Record<string, Record<string, FeatureConfig>>

export const featureConfig = {
  DEV: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['DEV'],
  },
  TEST: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['TEST'],
  },
  STAGE: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['STAGE'],
  },
  PROD: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['PROD'],
  },
} as Record<'DEV' | 'TEST' | 'STAGE' | 'PROD', FeatureConfig>
